import PenName from '@assets/icons/penname.svg'
import { Icon } from './Icon'

export const PenNameIcon = Icon(PenName)
